var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Person.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["p"], 
["isTablet"], 
function (l_p, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("p", l_p);
frame.set("isTablet", kwargs.hasOwnProperty("isTablet") ? kwargs["isTablet"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_2 = "";t_2 += "<li class=\"Person\">\n        <div class=\"Person-videoContainer\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isTablet")) {
t_2 += "\n                <div class=\"Person-img u-Cover u-Preload\">\n                    <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"mobile"), env.opts.autoescape);
t_2 += "\" alt=\"";
t_2 += runtime.suppressValue((lineno = 5, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Фото сотрудника"])), env.opts.autoescape);
t_2 += " - ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
t_2 += "\">\n                </div>\n            ";
;
}
else {
t_2 += "\n                ";
if(runtime.memberLookup((l_p),"videoMp4") || runtime.memberLookup((l_p),"videoWebm")) {
t_2 += "\n                    <video class=\"Person-video\" preload>\n                        <source src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"videoMp4"), env.opts.autoescape);
t_2 += "\" type=\"video/mp4\"/>\n                        <source src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"videoWebm"), env.opts.autoescape);
t_2 += "\" type=\"video/webm\"/>\n                    </video>\n                ";
;
}
else {
t_2 += "\n                    <div class=\"Person-img u-Cover u-Preload\">\n                        <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"mobile"), env.opts.autoescape);
t_2 += "\" alt=\"";
t_2 += runtime.suppressValue((lineno = 15, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Фото сотрудника"])), env.opts.autoescape);
t_2 += " - ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
t_2 += "\">\n                    </div>\n                ";
;
}
t_2 += "\n            ";
;
}
t_2 += "\n        </div>\n\n        <div class=\"Frame\">\n            <div class=\"Frame-side Frame-side--right\"></div>\n            <div class=\"Frame-side Frame-side--bottom\"></div>\n        </div>\n\n        <div class=\"Person-text\">\n            <div class=\"Person-title\">";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
t_2 += "</div>\n            <div class=\"Person-subTitle\">";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"subTitle"), env.opts.autoescape);
t_2 += "</div>\n        </div>\n    </li>";
t_2 += runtime.suppressValue((lineno = 30, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("Person");
context.setVariable("Person", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Person.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Person/Person.jinja
// module id = 94
// module chunks = 0